const envSettings = import.meta.env;

export default {
  ...envSettings,
  useNewSecurityService:
    envSettings.VITE_NEWFOIDENTITYPROVIDERDISABLED?.toLowerCase() !== "true",
};
